import { render, staticRenderFns } from "./grupe-vozila.editor.vue?vue&type=template&id=12416a3d&scoped=true&"
import script from "./grupe-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./grupe-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12416a3d",
  null
  
)

export default component.exports